import { render } from "./MainScreen.vue?vue&type=template&id=5d1a7772&scoped=true&ts=true"
import script from "./MainScreen.vue?vue&type=script&lang=ts"
export * from "./MainScreen.vue?vue&type=script&lang=ts"

import "./MainScreen.vue?vue&type=style&index=0&id=5d1a7772&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webeye-pro-frontend/webeye-pro-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d1a7772"]])

export default __exports__